<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" xl="7" lg="10" md="12" sm="10" >
        <v-card>
          <v-fade-transition>
            <v-overlay
              v-if="showOverlay"
              absolute
              color="#fff"
              :opacity="100">
              <v-progress-circular
                :size="100"
                :width="8"
                color="light-blue"
                indeterminate>
              </v-progress-circular>
            </v-overlay>
          </v-fade-transition>
          <div class="pa-2"
               style="background-color: #0091EA"/>

          <v-row align="start" justify="center" class="py-md-3 px-sm-5">
            <v-col cols="10" md="6" sm="6" class="pl-5">
              <v-row
                class="d-flex
                align-center
                justify-center
                justify-md-start
                justify-sm-start
                my-sm-4">
                <v-avatar size="100" class="elevation-3">
                  <v-img
                    :src="userInfo.url_logo || 'https://iauth.billpocket.com/img/icons/apple-touch-icon-152x152.png'"
                    :lazy-src="'https://iauth.billpocket.com/img/icons/apple-touch-icon-152x152.png'"
                    height="100"
                    alt="John"
                  />
                </v-avatar>
              </v-row>

              <v-row
                class="d-flex
                align-center
                justify-center
                justify-md-start
                justify-sm-start
                my-sm-2">
                <div>
                  <h1 class="font-weight-bold headline text-md-left text-sm-left text-center">
                    {{userInfo.nombre_comercial}}
                  </h1>
                  <p class="subtitle-2 mb-0 text-md-left text-sm-left text-center">
                    {{userInfo.description}}
                  </p>
                </div>
              </v-row>
            </v-col>
            <v-col cols="10" md="6" sm="6">
              <div>
                <v-alert
                  v-if="reasonInvaliURl === 'expired'"
                  type="warning"
                  color="warning"
                  icon="warning"
                  outlined
                >
                  Este link se encuentra vencido,
                      contacta a {{ userInfo.nombre_comercial }}
                      para activarlo o crear uno nuevo.
                      Si lo prefieres también puedes enviarle
                      un monto abierto a través de su link de Pago a Distancia
                </v-alert>
                <v-alert
                  v-if="reasonInvaliURl === 'paid'"
                  type="warning"
                  color="warning"
                  icon="warning"
                  outlined
                >
                  Este link ya fue pagado,
                      contacta a {{ userInfo.nombre_comercial }}
                      para activarlo o crear uno nuevo.
                      Si lo prefieres también puedes enviarle
                      un monto abierto a través de su link de Pago a Distancia
                </v-alert>
                <p class="title font-weight-bold mb-8">
                  Información del Pago
                </p>
                <p class="subheading font-weight-bold mb-0">
                  Monto a enviar
                  <span class="font-weight-black">(MXN)</span>
                </p>
                <VTextField
                  id="amount"
                  name="amount"
                  class="display-3 font-weight-regular"
                  height="60"
                  v-model="amount"
                  placeholder="0.00"
                  :color="color"
                  autocomplete="off"
                  prefix="$"
                  autofocus
                  clearable
                  :disabled="!amountEnabled"
                  @keyup="onlyForCurrency"
                  @focusout="formatting"
                  @click:clear="validateNextStep"
                />
              </div>
              <div class="mt-5">
                <p class="subheading font-weight-medium">
                  Mensaje
                  <span class="font-italic font-weight-light">(Opcional)</span>
                </p>
                <VTextField
                  id="message"
                  :disabled="messageControlDisabled"
                  name="message"
                  class="font-regular"
                  placeholder="Incluye tu nombre o referencia"
                  :color="color"
                  v-model="message"
                  :counter="minMsgLenght"
                  :maxlength="minMsgLenght"
                  prepend-inner-icon="message"
                  autocomplete="off"
                  clearable
                />
              </div>
              <div class="mt-7">
                <VBtn
                  :disabled="btnDisable"
                  block color="blue-grey darken-3" class="white--text"
                  @click="generateCheckout">
                  {{btnMsg}}
                </VBtn>
              </div>
            </v-col>
          </v-row>

          <v-fade-transition>
            <v-progress-linear v-if="showProgressLinear"
                               indeterminate
                               height="10"
                               color="light-blue"
            ></v-progress-linear>
          </v-fade-transition>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="showError"
      color="error"
      :timeout="7000"
      :top="true"
    >
      {{ msgError }}
      <VBtn
        dark
        text
        @click="showError = false"
      >
        Cerrar
      </VBtn>
    </v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable-next-line consistent-return */
/* eslint-disable prefer-promise-reject-errors */
import PagoDistanciaHelper from '@/helpers/pago-distancia.helper';
import typesCustomLink from '../constants/customlink';

export default {
  data: () => ({
    color: 'light-blue accent-4',
    reasonInvaliURl: '',
    showOverlay: true,
    showProgressLinear: false,
    btnMsg: 'Ingresa el monto',
    btnDisable: true,
    btnColor: 'light-blue accent-4',
    amount: '',
    message: '',
    userInfo: {},
    slug: '',
    minMsgLenght: process.env.VUE_APP_MSG_MIN_LENGTH,
    msgError: '¡Ups! Sucedió un problema al generar tu pago, intenta de nuevo.',
    showError: false,
    secondaryLink: '',
    linkType: null,
    amountEnabled: true,
    messageControlDisabled: false,
  }),
  beforeMount() {
    const { slug, uniquelink } = this.$route.params;
    this.slug = slug;
    this.secondaryLink = uniquelink;
    this.reasonInvaliURl = this.$route.query.redirect;
    const self = this;
    this.fetchAsyncUserData(slug)
      .then((result) => {
        const { receiver, description } = result.data;
        this.userInfo = {
          id: receiver.id,
          nombre_comercial: receiver.nombre_comercial,
          email: receiver.email,
          url_logo: receiver.url_logo,
          slug,
          description,
        };
        const titleMerchant = this.userInfo.nombre_comercial ? this.userInfo.nombre_comercial : '';
        window.document.title = `${titleMerchant} - Pago a distancia de Billpocket`;
        return this.getUniqueLinkInformation(slug, uniquelink);
      })
      .then((response) => {
        const currentLink = response.data;
        if (currentLink.success && currentLink.found) {
          if (currentLink.data.status === 1) {
            if (currentLink.data.link_type === typesCustomLink.WITH_AMOUNT_AND_EXPIRY
              || currentLink.data.link_type === typesCustomLink.WITH_OPEN_AMOUNT_AND_EXPIRY) {
              const currentDate = new Date();
              const expirationDate = new Date(currentLink.data.expired_at);
              expirationDate.setDate(expirationDate.getDate() + 1);
              expirationDate.setHours(0);
              expirationDate.setMinutes(0);
              expirationDate.setSeconds(0);
              if (currentDate >= expirationDate) {
                self.errorFetchingData = true;
                this.$router.push({ name: 'user-landing', params: { slug: this.slug }, query: { redirect: 'expired' } });
              }
            }
            self.link = currentLink.data;
            self.linkType = currentLink.data.link_type;
            self.validateLink();
          } else {
            this.$router.push({ name: 'user-landing', params: { slug: this.slug }, query: { redirect: 'expired' } });
            self.errorFetchingData = true;
            self.textError = 'El enlace de pago esta actualmente desactivado.';
          }
        } else {
          this.$router.push({ name: '404' });
          self.errorFetchingData = true;
        }
      })
      .catch((error) => {
        if (error.status && error.status === 404) {
          this.$router.push({ name: '404', params: { error } });
        } else {
          this.$router.push({ name: 'internal-error' });
        }
      })
      .finally(() => {
        this.showOverlay = false;
      });
  },
  methods: {
    getUniqueLinkInformation: (mainLink, customLink) => new Promise((resolve, reject) => {
      let currentStatus = 200;
      fetch(`${process.env.VUE_APP_CUSTOM_LINK_SERVICE}/${mainLink}/${customLink}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.VUE_APP_CUSTOM_LINK_APIKEY,
        },
      })
        .then((response) => {
          currentStatus = response.status;
          if (currentStatus >= 400) {
            reject({
              status: currentStatus,
              success: false,
            });
          }
          return response.json();
        })
        .then((currentLink) => {
          resolve({
            success: true,
            data: currentLink,
          });
        })
        .catch(() => ({
          success: false,
          status: currentStatus,
        }));
    }),
    validateLink() {
      const notEditableTypeLinks = [
        typesCustomLink.UNIQUE_WITHOUT_EXPIRES,
        typesCustomLink.WITH_AMOUNT_AND_TO_BE_USED_ONCE,
        typesCustomLink.WITH_AMOUNT_AND_EXPIRY,
        typesCustomLink.WITH_RELATED_PURCHASE_FOR_BP_DEVICES];
      if (notEditableTypeLinks.includes(this.linkType)) {
        this.amountEnabled = false;
        this.btnDisable = false;
        this.amount = this.link.amount.toString();
        this.btnMsg = 'Siguiente';
      }
      if (this.link.description) {
        this.message = this.link.description;
        this.messageControlDisabled = true;
      }
    },
    fetchAsyncUserData: (slug) => new Promise((resolve, reject) => {
      let status = 200;
      fetch(`${process.env.VUE_APP_FETCH_USER_DATA}/${slug}`)
        // eslint-disable-next-line consistent-return
        .then((response) => {
          status = response.status;
          if (status >= 400) {
            reject({
              success: false,
              status,
            });
          } else {
            return response.json();
          }
        })
        .then((data) => {
          resolve({
            data,
            status,
          });
        })
        .catch((err) => {
          reject(new Error({
            success: false,
            status: 500,
            err,
          }));
        });
    }),
    postAsyncPaywith: async (payload) => {
      const promiseData = await fetch(`${process.env.VUE_APP_PAYWITH_SERVICE}`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const response = await promiseData.json();
      const { status } = promiseData;
      if (status !== 201) {
        throw new Error('Problemas al continuar, intenta nuevamente.');
      }
      return {
        response,
        status,
      };
    },
    generateCheckout() {
      this.btnMsg = 'Espere un momento...';
      this.btnDisable = true;
      this.btnColor = 'light-blue lighten-4';
      this.showProgressLinear = true;
      const linkToBeUsedOnce = PagoDistanciaHelper.linkMustBeUsedOnce(this.linkType);
      const availablePaymentPlans = this.link.available_rates ? this.link.available_rates : [];
      const payload = {
        externalId: this.userInfo.nombre_comercial,
        items: [
          `${process.env.VUE_APP_DESCRIPTION_ITEM}`,
        ],
        total: parseFloat(this.amount.replace(/,/g, '')),
        description: this.message,
        real_user_id: this.userInfo.id,
        linkInformation: {
          usernameRemotePayment: this.slug,
          secondaryLink: this.secondaryLink,
          merchantDescription: this.userInfo.description,
          uniqueLink: linkToBeUsedOnce,
          linkDescription: this.link.description,
          purchaseId: this.link.purchase_id,
        },
        rates: availablePaymentPlans,
        preselectedPaymentPlan: this.link.is_fixed_term,
      };
      this.postAsyncPaywith(payload)
        .then((data) => {
          const { checkoutId } = data.response;
          setTimeout(() => {
            window.location.href = `${process.env.VUE_APP_PAYWITH_APP}/${checkoutId}?username=${this.userInfo.slug}`;
          }, 500, checkoutId);
        })
        .catch(() => {
          this.showError = true;
          this.btnMsg = 'Intentar de nuevo';
          this.btnDisable = false;
          this.showProgressLinear = false;
        });
    },
    onlyForCurrency($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.amount.indexOf('.') !== -1)) { // 46 is dot
        $event.preventDefault();
      }
      // restrict to 2 decimal places
      /* if (this.amount != null && this.amount.indexOf('.') > -1
      && (this.amount.split('.')[1].length > 1)) {
        $event.preventDefault();
      } */

      const valueToCheck = (this.amount === null) ? '' : this.amount;
      this.amount = valueToCheck// Keep only digits and decimal points:
        // Keep only digits and decimal points:
        .replace(/[^\d.]/g, '')
        // Remove duplicated decimal point, if one exists:
        .replace(/^(\d*\.)(.*)\.(.*)$/, '$1$2$3')
        // Keep only two digits past the decimal point:
        .replace(/\.(\d{2})\d+/, '.$1')
        // Add thousands separators:
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      const amount = parseFloat(this.amount.replace(/,/g, ''));

      if (Number.isNaN(amount)) {
        this.btnDisable = true;
        this.btnMsg = 'Ingresa el monto';
      } else if (parseInt(`${amount}`, 10) < 10) {
        this.btnDisable = true;
        this.btnMsg = 'Monto mínimo de $10';
      } else {
        this.btnDisable = false;
        this.btnMsg = 'Siguiente';
      }
    },
    formatting() {
      if (this.amount === null) return;

      const number = parseFloat(this.amount.replace(/,/g, '')).toFixed(2);
      this.amount = number// Keep only digits and decimal points:
        // Keep only digits and decimal points:
        .replace(/[^\d.]/g, '')
        // Remove duplicated decimal point, if one exists:
        .replace(/^(\d*\.)(.*)\.(.*)$/, '$1$2$3')
        // Keep only two digits past the decimal point:
        .replace(/\.(\d{2})\d+/, '.$1')
        // Add thousands separators:
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    validateNextStep() {
      setTimeout(() => {
        this.btnDisable = true;
        this.btnMsg = 'Ingresa el monto';
      }, 10);
    },
  },
};
</script>
<style>

  #amount {
    max-height: 80px;
  }
  #amount::placeholder {
    line-height: 60px;
  }

  @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0)
  { @media {
    #amount {
      max-height: 80px;
    }
    #amount::placeholder {
      padding-top: 1px;
      line-height: 70px;
    }
  }}

  .centered-input input {
    text-align: center
  }
</style>
